/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Person_Validation_RoleInputs */

const fr_person_validation_role = /** @type {(inputs: Person_Validation_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un rôle valide. Une équipe ne peut être attribuée qu’à un responsable d’équipe.`)
};

const en_person_validation_role = /** @type {(inputs: Person_Validation_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a valid role. Only a team manager can be assigned a team.`)
};

/**
* | output |
* | --- |
* | "Choose a valid role. Only a team manager can be assigned a team." |
*
* @param {Person_Validation_RoleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const person_validation_role = /** @type {((inputs?: Person_Validation_RoleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Person_Validation_RoleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_person_validation_role(inputs)
	return fr_person_validation_role(inputs)
});